import { indexItems } from '@/mocks/home';

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">漫画分类</h2>
          <p className="text-sm md:text-base text-foreground-500">七大主题分类，快速找到你喜欢的漫画类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="flex flex-col items-center gap-3 p-5 md:p-6 bg-background-100 rounded-xl hover:bg-primary-50/40 transition-colors group cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="font-semibold text-foreground-950 text-sm md:text-base mb-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-accent-500 font-medium">{item.count} 部</p>
                <p className="text-xs text-foreground-500 mt-1 hidden sm:block">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}